//@ts-ignore
import util from "vue2-filters/src/util";
//@ts-ignore
import * as stringFilters from "vue2-filters/src/string";
//@ts-ignore
import * as arrayFilters from "vue2-filters/src/array";
//@ts-ignore
import * as otherFilters from "vue2-filters/src/other";
const Vue3FiltersPlugin = {
    install: function (app) {
        util.each(stringFilters, function (value, key) {
            app.config.globalProperties.$filters = {
                ...app.config.globalProperties.$filters,
                [key]: value,
            };
        });
        util.each(otherFilters, function (value, key) {
            app.config.globalProperties.$filters = {
                ...app.config.globalProperties.$filters,
                [key]: value,
            };
        });
        app.mixin({
            methods: { ...arrayFilters },
        });
    },
};
export default Vue3FiltersPlugin;
